import application from 'application/application';

const controller = 'DefaultPublicationsPublicationsDetailsController';

application.controller(controller, [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'helper',
	'$http',
	'API',
	'$sce',
	($rootScope, $scope, $state, $stateParams, helper, $http, API, $sce) => {
		$scope.publicationsIDs = $stateParams.id;
		$scope.idClientUser = $stateParams.idUsuarioCliente;

		/** Instância de armazenamento de resposta. */
		$scope.publication = helper
			.responseStore()
			.setItemsPerPage(10)
			.setCurrentPage($stateParams.paginaAtual);

		// const idParceiro = JSON.parse(
		// 	localStorage.getItem('__authenticationUserData__')
		// ).idParceiro;

		$scope.groupUserData = JSON.parse(
			localStorage.getItem('__groupUserData__')
		);
		$scope.groupSelected = localStorage.getItem('__groupSelected__');
		$scope.hasGroup = localStorage.getItem('__hasGroup__');

		$scope.highlightFilter = (text, searchTerms) => {
			if (!searchTerms || searchTerms.length === 0) {
				return $sce.trustAsHtml(text);
			} else if (!text) {
				return $sce.trustAsHtml(text);
			}

			const normalize = str =>
				str
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.toLowerCase();

			const getHighlightPositions = (text, search) => {
				const positions = [];
				const normalizedText = normalize(text);
				const normalizedSearch = normalize(search);
				let match;
				const searchRegex = new RegExp(normalizedSearch, 'g');

				while ((match = searchRegex.exec(normalizedText)) !== null) {
					positions.push({ start: match.index, length: search.length });
				}

				return positions;
			};

			const highlightText = (text, positions) => {
				let result = '';
				let lastIndex = 0;

				positions.sort((a, b) => a.start - b.start);

				const mergedPositions = [];
				let currentPos = positions[0];

				for (let i = 1; i < positions.length; i++) {
					const nextPos = positions[i];

					if (nextPos.start <= currentPos.start + currentPos.length) {
						currentPos.length =
							Math.max(
								currentPos.start + currentPos.length,
								nextPos.start + nextPos.length
							) - currentPos.start;
					} else {
						mergedPositions.push(currentPos);
						currentPos = nextPos;
					}
				}

				currentPos && mergedPositions.push(currentPos);

				if (mergedPositions.length) {
					mergedPositions.forEach(pos => {
						if (pos.start >= lastIndex) {
							result += text.substring(lastIndex, pos.start);
							result += `<span class="highlight">${text.substring(
								pos.start,
								pos.start + pos.length
							)}</span>`;
							lastIndex = pos.start + pos.length;
						}
					});

					result += text.substring(lastIndex);
				} else {
					result = text;
				}

				return result;
			};

			let highlightPositions = [];

			searchTerms.forEach(search => {
				highlightPositions = highlightPositions.concat(
					getHighlightPositions(text, search)
				);
			});

			const highlightedText = highlightText(text, highlightPositions);

			setTimeout(() => {
				const paragrafo = document.createElement('p');

				paragrafo.innerHTML = highlightedText;

				const meuElemento = document.getElementById('publiContent');

				meuElemento.innerHTML = '';
				meuElemento.appendChild(paragrafo);
			}, 800);
		};

		$scope.highlightFilterDespacho = (text, searchTerms) => {
			if (!searchTerms || searchTerms.length === 0) {
				return $sce.trustAsHtml(text);
			} else if (!text) {
				return $sce.trustAsHtml(text);
			}

			const normalize = str =>
				str
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.toLowerCase();

			const getHighlightPositions = (text, search) => {
				const positions = [];
				const normalizedText = normalize(text);
				const normalizedSearch = normalize(search);
				let match;
				const searchRegex = new RegExp(normalizedSearch, 'g');

				while ((match = searchRegex.exec(normalizedText)) !== null) {
					positions.push({
						start: match.index,
						length: search.length
					});
				}

				return positions;
			};

			const highlightText = (text, positions) => {
				let result = '';
				let lastIndex = 0;

				positions.sort((a, b) => a.start - b.start);

				const mergedPositions = [];
				let currentPos = positions[0];

				for (let i = 1; i < positions.length; i++) {
					const nextPos = positions[i];

					if (nextPos.start <= currentPos.start + currentPos.length) {
						currentPos.length =
							Math.max(
								currentPos.start + currentPos.length,
								nextPos.start + nextPos.length
							) - currentPos.start;
					} else {
						mergedPositions.push(currentPos);
						currentPos = nextPos;
					}
				}
				mergedPositions.push(currentPos);

				mergedPositions.forEach(pos => {
					if (pos) {
						if (pos.start >= lastIndex) {
							result += text.substring(lastIndex, pos.start);
							result += `<span class="highlight">${text.substring(
								pos.start,
								pos.start + pos.length
							)}</span>`;
							lastIndex = pos.start + pos.length;
						}
					}
				});
				result += text.substring(lastIndex);

				return result;
			};

			let highlightPositions = [];

			searchTerms.forEach(search => {
				highlightPositions = highlightPositions.concat(
					getHighlightPositions(text, search)
				);
			});

			const highlightedText = highlightText(text, highlightPositions);

			setTimeout(() => {
				const paragrafo = document.createElement('p');

				paragrafo.innerHTML = highlightedText;

				const meuElemento = document.getElementById('despachoContent');

				meuElemento.innerHTML = '';
				meuElemento.appendChild(paragrafo);
			}, 800);
		};

		$scope.recordPublication = responseStore => {
			let params = {
				id: $scope.publicationsIDs,
				idUsuarioCliente: $scope.idClientUser,
				campos:
					'cidadeComarcaDescricao,conteudo,dataHoraMovimento,dataPublicacao,descricaoCadernoDiario,descricaoDiario,despacho,idPublicacaoCliente,idTipoPalavraChave,nomeCadernoDiario,nomeDiario,numero,numeroCNJ,numeroProcesso,paginaFinalPublicacao,paginaInicialPublicacao,palavraChave,palavrasChave,varaDescricao,idCliente,nomeCliente'
			};

			if ($scope.hasGroup == 'true' && $scope.groupSelected == 'true') {
				params.idGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.publications, 'GET'),
				params
			})
				.then(({ data }) => {
					const publication = data.itens[0];

					const palavrasChave = publication.palavrasChave.map(
						item => item.palavraChave
					);

					$scope.highlightFilter(publication.conteudo, palavrasChave);

					$scope.highlightFilterDespacho(publication.despacho, palavrasChave);

					responseStore.setItems([publication]);
				})

				.finally(() => responseStore.setReady(true));
		};

		$scope.renderProcesses = (processes, number) => {
			let processesArr = processes
				.filter(
					process =>
						process.numeroProcesso.replace(/[^0-9]/g, '') !=
						number.replace(/[^0-9]/g, '')
				)
				.map(process => $scope.formatCnj(process.numeroProcesso));

			if (number) processesArr.unshift($scope.formatCnj(number));

			return processesArr;
		};

		$scope.formatCnj = input => {
			if (input.length != 20 || isNaN(input)) return input;

			return input.replace(
				/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/,
				'$1-$2.$3.$4.$5.$6'
			);
		};

		$scope.recordPublication($scope.publication);
	}
]);

export default controller;
